document.addEventListener('DOMContentLoaded', () => {
	const accordions = document.querySelectorAll('.faqs__accordion');

	accordions.forEach((accordion) => {
		const buttons = accordion.querySelectorAll('.faqs__question');

		if ( buttons.length ) {
			const first = buttons[0];
			const firstAnswer = getAnswer(first);
			openItem(first, firstAnswer);
		}

		buttons.forEach((button) => {
			button.addEventListener('click', () => {
				const isOpen = button.getAttribute('aria-expanded') === 'true';
				const answer = getAnswer(button);

				if ( isOpen ) {
					closeItem(button, answer);
				} else {
					closeAll(buttons);
					openItem(button, answer);
				}
			});
		});
	});
});

function getAnswer(button) {
	const id = button.getAttribute('aria-controls');
	return id ? document.getElementById(id) : button.nextElementSibling;
}

function openItem(button, answer) {
	if ( ! answer ) return;
	button.setAttribute('aria-expanded', 'true');
	answer.setAttribute('aria-hidden', 'false');
	// inert acompana a aria-hidden: sin el, los links del panel cerrado siguen
	// en el orden de tabulacion y el lector de pantalla termina anunciando el
	// foco sobre contenido que la pagina declaro oculto.
	answer.removeAttribute('inert');
	button.closest('.faqs__item')?.classList.add('is-open');
}

function closeItem(button, answer) {
	if ( ! answer ) return;
	button.setAttribute('aria-expanded', 'false');
	answer.setAttribute('aria-hidden', 'true');
	answer.setAttribute('inert', '');
	button.closest('.faqs__item')?.classList.remove('is-open');
}

function closeAll(buttons) {
	buttons.forEach((btn) => closeItem(btn, getAnswer(btn)));
}